import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight, Droplet, Droplets, Layers } from "lucide-react";
import { COMPANY, NAV, PRODUCTS, IMAGES } from "../../lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-white/80">
      <div className="container-x py-20 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-3">
          <div className="flex items-center gap-3">
            <img src={IMAGES.markWhite} alt="OneHarvest" className="h-11 w-11 object-contain" />
            <div>
              <div className="font-display font-extrabold text-xl tracking-tight text-white">ONEHARVEST</div>
            </div>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-white/60 max-w-xs">
            {COMPANY.philosophy}
          </p>
          <p className="mt-6 kicker text-flame">{COMPANY.serviceArea}</p>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white font-display font-bold text-sm mb-4">Categories</h4>
          <ul className="space-y-2.5 text-sm">
            {[
              { label: "Absorbents & Spill Control", to: "/absorbents", icon: Droplet },
              { label: "Water Treatment & Management", to: "/water-treatment", icon: Droplets },
              { label: "Ground Protection", to: "/ground-protection", icon: Layers },
            ].map((c) => (
              <li key={c.to}>
                <Link to={c.to} data-testid={`footer-category-${c.to.replace(/\//g, "")}`} className="group inline-flex items-center gap-2.5 text-white/60 hover:text-flame transition-colors">
                  <c.icon className="h-4 w-4 text-flame/70 shrink-0 group-hover:text-flame transition-colors" />
                  {c.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white font-display font-bold text-sm mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            {NAV.filter((n) => !["/", "/absorbents", "/water-treatment", "/ground-protection"].includes(n.to)).map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-white/60 hover:text-flame transition-colors">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white font-display font-bold text-sm mb-4">Products</h4>
          <ul className="space-y-2.5 text-sm">
            {PRODUCTS.map((p) => (
              <li key={p.slug}>
                <Link to={`/products/${p.slug}`} className="text-white/60 hover:text-flame transition-colors">{p.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white font-display font-bold text-sm mb-4">Talk to a Solutions Manager</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-flame" /><a href={`tel:${COMPANY.phone}`} className="hover:text-flame">{COMPANY.phone}</a></li>
            <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-flame" /><a href={`mailto:${COMPANY.email}`} className="hover:text-flame">{COMPANY.email}</a></li>
            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 text-flame mt-0.5" /><span className="text-white/60">{COMPANY.address}</span></li>
          </ul>
          <Link to="/request-quote" data-testid="footer-request-quote" className="mt-6 inline-flex items-center gap-2 bg-flame text-white px-5 py-2.5 text-sm font-semibold hover:bg-flame/90 transition-colors">
            Request a Quote <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</span>
          <span>{COMPANY.hours}</span>
        </div>
      </div>
    </footer>
  );
}
